<template>
  <div class="error-row-wrapper">
    <div v-show="errorMessage && errorMessage.length > 0" class="alert alert-danger failed spacer">{{ errorMessage }}<span class="float-right" @click="clearError()"><font-awesome-icon icon="eraser" /></span></div>
  </div>
</template>

<script>
//
// Purely presentational: the message is owned by the parent (every user passes
// :errorMessage and listens on @clearError, and PageViewMixin holds the state),
// so this component only renders it and reports the click.
//
// It used to carry its own copies of lookForServiceLevelMessage() and
// anyErrorAtServiceLevel() plus the errorflag/errorinfo getters. Those were
// stale duplicates of the PageViewMixin versions, called by nobody, and they
// assigned to the readonly errorMessage prop.
//
export default {
  name: 'ErrorRow',
  props: {
    errorMessage: {
      type: String,
      required: true
    }
  },
  methods: {
    clearError () {
      // Do not clear the prop here — the parent clears its own state when it
      // handles this event.
      this.$emit('clearError')
    }
  }
}
</script>

<style lang="scss" scoped>
  .error-row-wrapper {
    margin-bottom: 10px;
    margin-bottom: 10px;
  }

  .spacer {
    margin-top: 10px;
  }
</style>
